import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#9CA4AA",
      d: "M18.939 21.789c-4.565 3.235-10.617 2.828-14.696-.632l4.879-4.06a6.254 6.254 0 0 0 9.42-6.227c-.006-.06-.01-.128-.05-.184a.265.265 0 0 0-.37-.063l-4.094 2.903a.66.66 0 0 1-.922-.16l-2.012-2.836a.664.664 0 0 1 .157-.923l4.07-2.883s-.012.004-.018.008q.019-.009.036-.021a.275.275 0 0 0-.037-.469 6.248 6.248 0 0 0-9.068 6.768l-5.4 3.384C-1.15 11.376.461 5.468 5.06 2.21 10.468-1.622 17.957-.346 21.79 5.061c3.831 5.407 2.555 12.896-2.85 16.728"
    }, null, -1)
  ]))]))
}
export default { render: render }